<meta name="appVersion" [content]="appVersion">
<router-outlet></router-outlet>
<ngx-ui-loader></ngx-ui-loader>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "large" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "true"><p style="color: white" > Loading... </p></ngx-spinner>

